import { MapDispatchToPropsFunction } from 'react-redux'
import { State } from 'interfaces/state'
import { requestDeleteRelationActionCreator } from 'actions/peergroupActions'
import { editRelationActionCreator, setShownSidebarPaneActionCreator } from 'actions/sidebarActions'
import { createRelationSelector, createPeergroupByRelationSelector } from 'selectors/peergroupSelectors'
import { connectOptionally, createPositiveRendererProps, NO_RENDER, OptionalRendererProps } from 'tangle-shared'
import { viewportSegmentSelector } from 'selectors/viewportSelectors'
import {
  SidebarPeergroupPopup,
  SidebarPeergroupPopupStateProps,
  SidebarPeergroupPopupDispatchProps,
  SidebarPeergroupPopupOwnProps,
} from 'components/features/pfm/SidebarPopup/SidebarPeergroupPopup'
import {
  hidePopupFeedFilterActionCreator,
  selectFeedFilterActionCreator,
  registerPopupFeedFilterTimeoutActionCreator,
  randomizeFeedRelationActionCreator,
} from 'actions/feedActions'
import { filterRandomRelationStateSelector } from 'selectors/feedSelectors'

// a little crutch for avoiding one more component
type FeedfilterPeergroupPopupContainerOwnProps = SidebarPeergroupPopupOwnProps & { isEveryone: boolean }

const popupRelationSelector = createRelationSelector()
const popupPeergroupSelector = createPeergroupByRelationSelector()

const mapStateToProps = (state: State, ownProps: FeedfilterPeergroupPopupContainerOwnProps): OptionalRendererProps<SidebarPeergroupPopupStateProps> => {
  const randomFeedRelationState = filterRandomRelationStateSelector(state)
  const randomFeedRelationData = randomFeedRelationState.data

  if (!randomFeedRelationData) {
    return NO_RENDER()
  }

  // crutch, need to rewrite peergroups state & store random feed relation there
  const [relation, peergroup] = ownProps.relationId === randomFeedRelationData.relation.id
    ? [randomFeedRelationData.relation, randomFeedRelationData.peergroup]
    : [popupRelationSelector(state, ownProps), popupPeergroupSelector(state, ownProps)]

  if (!relation || !peergroup) {
    return NO_RENDER()
  }

  return createPositiveRendererProps({
    relation,
    peergroup,
    viewportSegment: viewportSegmentSelector(state),
    isRandomizing: randomFeedRelationState.isRandomizing,
    hideTimeoutId: state.app.feed.filterPopup.hideTimeoutId,
    isOnFeedPage: true,
  })
}

const mapDispatchToProps: MapDispatchToPropsFunction<
  SidebarPeergroupPopupDispatchProps,
  FeedfilterPeergroupPopupContainerOwnProps
> = (dispatch, ownProps) => ({
  onSelectFeedfilter: () => {
    if (ownProps.isEveryone) {
      dispatch(selectFeedFilterActionCreator({
        type: 'feedgroup',
        slug: 'everyone',
      }))
    } else {
      dispatch(selectFeedFilterActionCreator({
        type: 'peergroup',
        relationId: ownProps.relationId,
      }))
    }

    dispatch(setShownSidebarPaneActionCreator(null))
  },
  onEdit: () => dispatch(editRelationActionCreator(ownProps.relationId)),
  onRemove: () => dispatch(requestDeleteRelationActionCreator(ownProps.relationId)),
  onRandomize: () => dispatch(randomizeFeedRelationActionCreator.request({})),
  onHidePopup: () => dispatch(hidePopupFeedFilterActionCreator()),
  onRegisterHideTimeout: (timeoutId) => dispatch(registerPopupFeedFilterTimeoutActionCreator(timeoutId)),
})

export const FeedfilterPeergroupPopupContainer = connectOptionally<
  SidebarPeergroupPopupStateProps,
  SidebarPeergroupPopupDispatchProps,
  SidebarPeergroupPopupOwnProps,
  FeedfilterPeergroupPopupContainerOwnProps
>(mapStateToProps, mapDispatchToProps)(SidebarPeergroupPopup)
